import React, { useEffect, useRef, useState } from 'react'
import { Textfit } from 'react-textfit'
import { g_fs, FS_LH_MAP, INVITESOCIALMEDIASIM_ARR, HUMANSIM_ICON, ALLDEFAULTIMGS, ILOOKUPTEMPLATESINFO_MAP } from '../../../../../../../../../config/constants'
import { title_0, title_1, title_2 } from '../../../../../constants'
import { Invdate, Timelineobj } from '../../../../../../../../../components'
import { iconwrapper } from '../../../../../../../../../config/commonfunctions'
import { GALLERY_ICON, ITINERARY_ICON, RSVP_ICON, SEATINGS_ICON, RSVPTELEPHONE_ICON, GUESTBOOK_ICON, REGISTRY_ICON, SMALLERMORE_ICON, SOCIALMEDIA_ICON, PROMOTE_ICON, ARROWDOWN_ICON, PLAY_ICON, PAUSE_ICON, EXPAND_ICON } from '../../../../../../../../../config/svgicons'
import { allimages } from '../../../../../../../../../assets/invitationcard/index1'
import Jfmap from '../../../../../../../../../components/Jfmap/Jfmap'
import T1border from '../T1border/T1border'
import Runsvg from '../../../../../../../../../components/Runsvg/Runsvg'
import './T1simmobile.css'
import { S3CLOUD_CLOUDFRONT, S3CLOUD_CLOUDFRONT_ASSET } from '../../../../../../../../../config/s3directories'

const DEFAULTPARTYPROFILEIMG_MALE = 'invitation/party/m1.png'
const DEFAULTPARTYPROFILEIMG_FEMALE = 'invitation/party/f1.png'

const INFINITELOOP_MODE = 2
const EMPTY_SVG = 0

const debug_guideline = false
const maintext_fs = g_fs
const location_fs = g_fs
const schedule_fs = g_fs
const map_fs = g_fs
const qn_fs = g_fs
const howwemet_fs = maintext_fs
const proposal_fs = maintext_fs

const iframedom = {
    width: "",
    height: "",
    src: "",
    frameBorder: "",
    allow: "",
}

function useLongPress() {
    return function (callback) {
        let timeout;
        let preventClick = false;

        function start() {
            timeout = setInterval(() => {
                preventClick = true;
                callback();
            }, 100);
        }

        function clear() {
            // Get a reference to the last interval + 1
            const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

            // Clear any timeout/interval up to that id
            for (let i = 1; i < interval_id; i++) {
                window.clearInterval(i);
            }

            timeout && clearInterval(timeout);
            preventClick = false;
        }

        function clickCaptureHandler(e) {
            if (preventClick) {
                e.stopPropagation();
                preventClick = false;
            }
        }

        return {
            onMouseDown: start,
            onTouchStart: start,
            onMouseUp: clear,
            onMouseLeave: clear,
            onTouchMove: clear,
            onTouchEnd: clear,
            onClickCapture: clickCaptureHandler
        };
    }
}

function T1Single_MOBILE({ heroimgs, wt }) {
    return <img
        alt={''}
        style={{
            position: 'relative',
            width: '100%',
            height: wt,
            display: 'block',
            overflow: 'hidden',
            objectFit: 'cover'
        }}
        src={(heroimgs && heroimgs[0])
            ? heroimgs[0]
            : null}
    />
}


function T1Marquee_MOBILE({ heroimgs = [], wt }) {
    const marqueeRef = useRef(null);
    const animationRef = useRef(null);

    const [adjustedspeed, setAdjustedspeed] = useState(0); // pixels per second
    const [contentWidth, setContentWidth] = useState(0);

    useEffect(() => {
        if (!heroimgs.length || !wt) return;
        const totalWidth = wt * heroimgs.length;
        setContentWidth(totalWidth);
        setAdjustedspeed((totalWidth / 500) * 100); // your original logic — can tweak multiplier
    }, [heroimgs, wt]);

    useEffect(() => {
        if (!contentWidth || !adjustedspeed || !marqueeRef.current) return;

        const marquee = marqueeRef.current;
        let offset = 0;
        let lastTimestamp = performance.now();

        const animate = (timestamp) => {
            const deltaTime = (timestamp - lastTimestamp) / 1000; // in seconds
            lastTimestamp = timestamp;

            offset -= adjustedspeed * deltaTime; // pixels = speed (px/sec) * time (sec)

            if (Math.abs(offset) >= contentWidth) {
                offset = 0;
            }

            marquee.style.transform = `translateX(${offset}px)`;
            animationRef.current = requestAnimationFrame(animate);
        };

        animationRef.current = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationRef.current);
    }, [adjustedspeed, contentWidth]);

    return (
        <div
            style={{
                overflow: 'hidden',
                width: wt,
                height: wt,
                whiteSpace: 'nowrap',
                position: 'relative',
            }}
        >
            <div
                ref={marqueeRef}
                style={{
                    display: 'flex',
                    willChange: 'transform',
                }}
            >
                {[...heroimgs, ...heroimgs].map((img, idx) => (
                    <img
                        key={idx}
                        src={img}
                        style={{
                            width: wt,
                            height: wt,
                            objectFit: 'cover',
                            flexShrink: 0,
                        }}
                    />
                ))}
            </div>
        </div>
    );
}

function T1Slideshow_MOBILE({ heroimgs, wt, mainimg_ref }) {
    const duration = heroimgs.length * 4; // 4s per image
    return (
        <div
            ref={mainimg_ref}
            style={{
                overflow: "hidden",
                position: "relative",
                width: wt,
                height: wt,
            }}
        >
            {heroimgs.map((img, i) => (
                <img
                    key={i}
                    src={img}
                    className="slideshow-img"
                    style={{
                        animation: `fadecycle ${duration}s infinite`,
                        animationDelay: `${i * 4}s`, // shift start for each image
                        width: wt,
                        height: wt,
                    }}
                />
            ))}

            <style>{`
          .slideshow-img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            top: 0;
            left: 0;
            opacity: 0;
          }
  
          @keyframes fadecycle {
            0% { opacity: 1; }
            33.3333% { opacity: 1; }
            50% { opacity: 0; }
            83.3333% { opacity: 0; }
            100% { opacity: 1; }
          }
        `}</style>
        </div>
    );
}

// function T1Slideshow_MOBILE({ heroimgs, wt, aspectRatio }) {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [fadeIndex, setFadeIndex] = useState(0);
//     const [fade, setFade] = useState(true);
//     useEffect(() => {
//         const intervalId = setInterval(() => {
//             setFade(false); // Start fade-out effect
//             setTimeout(() => {
//                 setCurrentIndex((prevIndex) => (prevIndex + 1) % heroimgs.length);
//                 setFade(true); // Start fade-in effect after image change
//                 setTimeout(() => {
//                     setFadeIndex((prevIndex) => (prevIndex + 1) % heroimgs.length);
//                 }, 500); // Delay fadeIndex update for smoother transition
//             }, 1000); // Extended fade time for a smoother effect
//         }, 4000); // Increased time between transitions for smooth effect

//         return () => clearInterval(intervalId);
//     }, [heroimgs.length]);

//     return (
//         <div
//             key={currentIndex + 'slideshow'}
//             style={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 height: 'auto',
//                 overflow: 'hidden',
//                 position: 'relative',
//                 width: wt,
//             }}>
//             <img

//                 src={heroimgs[currentIndex]}
//                 style={{
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'cover',
//                     aspectRatio: aspectRatio,
//                     transition: 'slideshowopacity 12s infinite',
//                 }}
//             />

//             <style>
//                 {`
//                     @keyframes slideshowopacity {
//                         0% {
//                             opacity: 1;
//                           }
//                           33.3333% {
//                             opacity: 1;
//                           }
//                           50% {
//                             opacity: 0;
//                           }
//                           83.3333% {
//                             opacity: 0;
//                           }
//                           100% {
//                             opacity: 1;
//                           }
//                     }
//                 `}
//             </style>

//         </div>
//     );
// }


function T1simmobile(props) {

    const {
        wt, ht, displayseq, displayonoffmap, displaytxtmap,
        textures, styleborder, styleborderwt, styleborderbr, stylebordercolor,
        name, spousename, ntm, fc, priff, secff, locationff, btmbarff, datetimeff,
        images, itype, maintext, css_map, location, location_map, mapmode,
        lat, long, countdown, date_w, date_e, time, dt_type, whowwemet, stylesep, wproposal,
        schedules, qnas, locdescript, locurl, styletype, prebuildtemplatedesign_map, rsvpactive, socialmedias,
        promote, menutype, styleorientationmobile = 0, styleformationmobile = 0,
        menuicongate, party, partyproperties, heroimgs,
        heroimglayout, templatetype, templateattr_map, menuattr_map, heroimgattr_map, heroimgdevice_map
    } = props

    const scrollcontainerref = useRef(null)
    const [menustyle, setMenustyle] = useState({})
    const [startrunsvg, setStartrunsvg] = useState(false)
    const [stylenavupdate, setStylenavupdate] = useState(-1)
    const [svgstate, setSvgstate] = useState('PLAYING') // PLAYING, PAUSE
    const [nameposchange, setNameposchange] = useState(false) // name position change due to background
    const [mapiframe, setMapiframe] = useState(iframedom)
    const [imgcss_map, setImgcss_map] = useState({})
    const [svgoverlay_map, setSvgoverlay_map] = useState({})

    const onLongPress = useLongPress();

    useEffect(() => {
        setStartrunsvg(true)
    }, [])

    useEffect(() => {
        setMenustyle(menuattr_map[templatetype])
        setImgcss_map(heroimgattr_map[templatetype]['css_map'])
        setSvgoverlay_map(heroimgattr_map[templatetype]['svgoverlay_map'])
        setStylenavupdate(stylenavupdate + 1)

        const { location_map } = props
        if (location_map) {

            const { googleiframesrc } = location_map

            const parseIframeAttributes = (iframeString) => {
                // Use a DOMParser to parse the iframe string
                const parser = new DOMParser();
                const doc = parser.parseFromString(iframeString, "text/html");
                const iframeElement = doc.querySelector("iframe");

                // Extract attributes from the iframe element and convert them to an object
                const attributes = {};
                Array.from(iframeElement.attributes).forEach((attr) => { attributes[attr.name] = attr.value; });

                return { width: '100%', height: 150, src: attributes.src, frameBorder: '' };
            };

            const local_googleiframesrc = parseIframeAttributes(googleiframesrc)

            setMapiframe(local_googleiframesrc)

        }

    }, [props])

    function scrollup() {
        scrollcontainerref.current.scrollTop = scrollcontainerref.current.scrollTop > 1
            ? scrollcontainerref.current.scrollTop - 10
            : 0
    }

    function scrolldown() {
        scrollcontainerref.current.scrollTop = scrollcontainerref.current.scrollTop + 10;
    }

    const sep_dom = stylesep && stylesep.length > 0 ? <div style={{ width: '100%', height: 20, marginTop: 20, color: props.fc, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null

    useEffect(() => {
        const { bgformat } = allimages.get(styletype)['t1']

        let curr_bgformat = bgformat[parseInt(styleformationmobile)]
        const { affectnamepos } = curr_bgformat['MOBILE']
        if (affectnamepos && affectnamepos.state) {
            setNameposchange(true)
        }
        else {
            setNameposchange(false)
        }

    }, [styleformationmobile, styleorientationmobile])

    const bg = () => {

        const { background, bgformat } = allimages.get(styletype)['t1']
        let curr_bgformat = bgformat[styleformationmobile]
        let curr_orientation = curr_bgformat['orientation_allow_listmobile'][parseInt(styleorientationmobile)]

        let firstimg_orientation = curr_orientation['img1']
        let secondimg_orientation = curr_orientation['img2']

        let firstimg_positionincard = curr_bgformat['MOBILE']['bg1']
        let secondimg_positionincard = curr_bgformat['MOBILE']['bg2']

        let image1_url = firstimg_positionincard ? 'url(' + background[firstimg_positionincard]['url'][firstimg_orientation].replace('lookup', 'edit') + ')' : null
        let image2_url = secondimg_positionincard ? 'url(' + background[secondimg_positionincard]['url'][secondimg_orientation].replace('lookup', 'edit') + ')' : null

        return [
            <div
                key={'tsim_a'}
                className={`${firstimg_positionincard}_m_simulator`}
                style={{ backgroundImage: image1_url, position: 'absolute', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', zIndex: 998, }}
            />,
            <div
                key={'tsim_b'}
                className={`${secondimg_positionincard}_m_simulator`}
                style={{ backgroundImage: image2_url, position: 'absolute', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', zIndex: 998, }}
            />
        ]

    }

    const mainimg_dom = heroimgdevice_map['MOBILE']
        ? <div style={{ width: '100%', height: 'auto', zIndex: 999, position: 'relative' }}>

            <div style={{ height: 'calc( 100% - 40px )', width: '100%', position: 'absolute', display: 'flex', margin: '20px 0px', zIndex: 1 }}>
                <Runsvg startrunsvg={startrunsvg} svgoverlay_map={svgoverlay_map} svgstate={svgstate} device={'MOBILE'} />
            </div>
            {(svgoverlay_map && svgoverlay_map['mainimg'] && svgoverlay_map['mainimg']['replay'] && svgoverlay_map['mainimg']['mode'] === INFINITELOOP_MODE && svgoverlay_map['mainimg']['svgitem'] !== EMPTY_SVG)
                ? <button
                    onClick={() => { setSvgstate(svgstate === 'PAUSE' ? 'PLAYING' : 'PAUSE') }}
                    style={{ color: svgoverlay_map['mainimg']['color'], border: 'none', bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', placeContent: 'center', padding: 0, margin: 5, backgroundColor: 'transparent', zIndex: 1 }}
                >
                    {iconwrapper({ 'PAUSE': PLAY_ICON, 'PLAYING': PAUSE_ICON }[svgstate], { width: 15, height: 15, display: 'flex' })}
                </button>
                : null}

            {{
                'single': <T1Single_MOBILE // DONE
                    heroimgs={heroimgs}
                    wt={wt}
                />,
                'marquee': <T1Marquee_MOBILE // DONE
                    imgcss_map={imgcss_map}
                    heroimgs={heroimgs}
                    wt={wt}
                />,
                'slideshow': <T1Slideshow_MOBILE // DONE
                    imgcss_map={imgcss_map}
                    heroimgs={heroimgs}
                    wt={wt}
                />
            }[heroimglayout]}

        </div>
        : null

    const maintext_dom = (maintext && maintext.length > 0)
        ? <div key={'mt'} style={{ fontSize: maintext_fs, lineheight: FS_LH_MAP[maintext_fs], color: fc, width: '100%', display: 'flex', justifyContent: 'center', alignSelf: 'center', textAlign: 'center', padding: '15px 25px 10px 25px', flexDirection: 'column', ...css_map['maintext'] }}>{maintext}</div>
        : <div key='mt' style={{ width: 0, height: 0, visibility: 'hidden' }} />

    const location_dom = location ?
        <div
            key={'loc'}
            style={{ fontSize: location_fs * 2.0625, color: fc, fontFamily: locationff, width: '100%', cursor: 'pointer', fontWeight: 'bold', zIndex: 999, display: 'flex', justifyContent: 'center', textAlign: 'center', padding: 15, flexDirection: 'row', whiteSpace: 'pre' }}
            onClick={() => { if (lat.length > 0 && long.length > 0) window.open("https://www.google.com/maps/search/?api=1&query=" + lat + "," + long, "_blank") }}>
            {location}
        </div>
        : <div key='loc' style={{ width: 0, height: 0, visibility: 'hidden' }} />

    const datetime_dom = React.cloneElement(
        <Invdate
            countdown={countdown}
            date_e={date_e}
            date_w={date_w}
            itype={itype}
            dt_type={dt_type}
            time={time}
            fc={fc}
            bgcolor={templateattr_map && templatetype ? templateattr_map[templatetype]['templatecolor'] : ''}
            from={'T1simmobile'}
            datetimeff={datetimeff}
        />,
        { key: 'datedom' }
    )
    //lineHeight: lh,

    const howwemet_dom = displayonoffmap['howwemet']
        ? <div key='howwemet' style={{ width: '100%', fontSize: howwemet_fs, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0px 25px 10px 25px' }}>
            {sep_dom}
            <div style={{ fontSize: howwemet_fs * 1.625, fontFamily: secff, fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                {displaytxtmap['howwemet']}
            </div>
            <div>{(whowwemet && whowwemet.length === 2) ? whowwemet[0] : ''}</div>
            <div style={{ lineHeight: FS_LH_MAP[howwemet_fs], ...css_map['howwemet'] }}>
                {(whowwemet && whowwemet.length === 2) ? whowwemet[1] : ''}
            </div>
        </div>
        : null

    const proposal_dom = displayonoffmap['proposal']
        ? <div key='proposal' style={{ width: '100%', fontSize: proposal_fs, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0px 25px 10px 25px' }}>
            {sep_dom}
            <div style={{ fontSize: proposal_fs * 1.625, fontFamily: secff, fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                {displaytxtmap['proposal']}
            </div>
            <div>{(wproposal && wproposal.length === 2) ? wproposal[0] : ''}</div>
            <div style={{ lineHeight: FS_LH_MAP[proposal_fs], ...css_map['proposal'] }}>{(wproposal && wproposal.length === 2) ? wproposal[1] : ''}</div>
        </div>
        : null

    const qns_dom = displayonoffmap['qna']
        ? <div key='qns' style={{ width: '100%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', userSelect: 'none' }}>
            {sep_dom}
            <div style={{ fontSize: qn_fs * 1.625, fontFamily: secff, lineHeight: FS_LH_MAP[qn_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                {displaytxtmap['qna']}
            </div>
            {qnas && qnas.map((qna, i) => {
                if (i % 2 === 0) {
                    return <div key={'qnas_doms' + i} style={{ color: fc, display: 'flex', width: '100%', flexDirection: 'column', justifyContent: 'center', flexWrap: 'wrap', padding: i === 0 ? '0px 25px 10px 25px' : '10px 25px' }}>
                        <div style={{ fontSize: qn_fs, fontWeight: 'bold', lineHeight: FS_LH_MAP[qn_fs], userSelect: 'none' }}>{qnas[i]}</div>
                        <div style={{ fontSize: qn_fs, lineHeight: FS_LH_MAP[qn_fs], userSelect: 'none' }}>{qnas[i + 1]}</div>
                    </div>
                }
                else {
                    return null
                }
            })}
        </div>
        : null


    // const schedule_dom = schedules && schedules.length > 0
    const schedule_dom = displayonoffmap['schedule']
        ? <div key='schedule' style={{ width: '100%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            {sep_dom}
            <div style={{ fontSize: schedule_fs * 1.625, fontFamily: secff, lineHeight: FS_LH_MAP[schedule_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                {displaytxtmap['schedule']}
            </div>
            {schedules.map((item, index) => {
                return (
                    <Timelineobj
                        from="InvitationsimulatorMOBILE"
                        key={'timeline' + index}
                        index={index}
                        bb={index !== schedules.length - 1 ? `1px solid ${fc}4d` : 'none'} // borderBottom
                        date_s={item[0]}
                        date_e={item[1]}
                        time_s={item[2]}
                        time_e={item[3]}
                        name={item[4]}
                        content={item[5]}
                        mapobj={item[8]}
                        itineraryobj={item[9]}
                        pri_fs={schedule_fs}
                        sec_fs={schedule_fs}
                        wt={'100%'}
                        dttimebox_wt={'max-content'}
                        content_ht={'max-content'}
                        fc={fc}
                        bgc={templateattr_map && templatetype ? templateattr_map[templatetype]['templatecolor'] : ''}
                        mapmode={mapmode}
                        expandbtn={true}
                    />
                )
            })}
        </div>
        : null

    const map_dom = {
        'GOOGLE': (displayonoffmap['map'] && mapiframe && Object.keys(mapiframe))
            ? <div key='map' style={{ color: fc, width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: 20, alignItems: 'center' }}>
                {sep_dom}
                <div style={{ fontSize: map_fs * 1.75, fontFamily: secff, lineHeight: FS_LH_MAP[map_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['map']}
                </div>
                <div style={{ position: 'relative', width: '100%', height: '100%', padding: '0px 20px' }}>
                    <iframe style={{ width: '100%', border: 'none' }}{...mapiframe}></iframe>
                    <div style={{ fontSize: map_fs, margin: '10px 5px', whiteSpace: 'pre-wrap', ...css_map['locdescript'] }}>
                        {location_map['locdescript']}
                    </div>
                </div>
            </div>
            : null,
        'LEAFLET': displayonoffmap['map']
            ? <div key='map' style={{ color: fc, width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: 20, alignItems: 'center' }}>
                {sep_dom}
                <div style={{ fontSize: map_fs * 1.625, lineHeight: FS_LH_MAP[map_fs], fontFamily: secff, fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['map']}
                </div>
                <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                    {iconwrapper(
                        EXPAND_ICON,
                        { transform: 'scale(0.75)', width: 21, height: 21, display: 'flex', borderRadius: 4, padding: 5, placeContent: 'center', alignItems: 'center', backgroundColor: 'white', boxShadow: 'rgba(0, 0, 0, 0.65) 0px 1px 5px', color: 'var(--maindark)', position: 'absolute', right: 21, zIndex: 401, margin: 5 }
                    )}
                    <Jfmap
                        markersData={[{ latLng: { lat: props.location_map['leafletlat'], lng: props.location_map['leafletlong'] } }]}
                        type={'small'}
                        smallstyle={{ height: 150, width: 'calc( 100% - 40px )', margin: '0px 20px' }}
                        zc={false}
                        gpsiconsize={[12, 20]}
                        mapmode={props.location_map['leafletmapmode']}
                    />
                    <div style={{ fontSize: map_fs, margin: '10px 5px', whiteSpace: 'pre-wrap', ...css_map['locdescript'] }}>
                        {location_map['locdescript']}
                    </div>
                </div>
            </div>
            : null
    }[location_map['maptype']]

    const party_dom = displayonoffmap['party']
        ? [
            <div key='party' style={{ width: '100%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                {sep_dom}
                <div style={{ fontFamily: secff, fontSize: qn_fs * 1.75, lineHeight: FS_LH_MAP[qn_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['party']}
                </div>
                {party.map((item, index) => {
                    // console.log('party', party)
                    // if ((index + 1) % 2 === 0) return
                    const firstitem = party[index]
                    const imgbr = (partyproperties && partyproperties['imageshape'] ? '100%' : 5)
                    const imgdim = 80
                    const contentht = 150
                    const smallfs = 7
                    const lgfs = 9
                    const firstitemimg =  (firstitem.photo === DEFAULTPARTYPROFILEIMG_MALE || firstitem.photo === DEFAULTPARTYPROFILEIMG_FEMALE)
                        ? (S3CLOUD_CLOUDFRONT_ASSET + firstitem.photo)
                        : (S3CLOUD_CLOUDFRONT + firstitem.photo)

                    return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', placeContent: 'center', padding: '0px 25px 30px 25px' }}>
                        <div id={firstitem.id} style={{ width: '100%', minHeight: contentht, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                            <img src={firstitemimg} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginBottom: 10 }} />
                            <div style={{ fontSize: lgfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{firstitem.name}</div>
                            <div style={{ fontSize: smallfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center', margin: '5px 0px' }}>{firstitem.title}</div>
                            <div style={{ fontSize: lgfs, textAlign: 'center' }}>{firstitem.info}</div>
                        </div>
                    </div>
                })}
            </div>,
            <div key='party' style={{ width: '100%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                {sep_dom}
                <div style={{ fontFamily: secff, fontSize: qn_fs * 1.75, lineHeight: FS_LH_MAP[qn_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['party']}
                </div>
                {party.map((item, index) => {
                    // if ((index + 1) % 2 === 0) return
                    const firstitem = party[index]
                    const imgbr = (partyproperties && partyproperties['imageshape'] ? '100%' : 5)
                    const imgdim = 80
                    const contentht = 90
                    const smallfs = 7
                    const lgfs = 9
                    console.log('firstitem.photo', firstitem.photo)
                    const firstitemimg =  (firstitem.photo === DEFAULTPARTYPROFILEIMG_MALE || firstitem.photo === DEFAULTPARTYPROFILEIMG_FEMALE)
                    ? (S3CLOUD_CLOUDFRONT_ASSET + firstitem.photo)
                    : (S3CLOUD_CLOUDFRONT + firstitem.photo)

                    return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', placeContent: 'center', padding: '0px 25px 30px 25px' }}>
                        <div id={firstitem.id} style={{ width: '100%', minHeight: contentht, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                            <img src={firstitemimg} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginBottom: 10 }} />
                            <div style={{ fontSize: lgfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{firstitem.name}</div>
                            <div style={{ fontSize: smallfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center', margin: '5px 0px' }}>{firstitem.title}</div>
                        </div>
                    </div>
                })}
            </div>
        ][partyproperties['format']]
        : null

    const rsvp_dom = rsvpactive
        ? <button key='rsvp' style={{ width: `calc( 100% - 40px )`, color: fc, fontFamily: secff, padding: '5px 0px', margin: '10px 20px', backgroundColor: templateattr_map && templatetype ? templateattr_map[templatetype]['templatecolor'] : '', border: `0.5px solid ${fc}`, borderRadius: 5 }}>RSVP</button>
        : null

    // inactive
    const socialmedia_dom = <div style={{ color: fc, display: 'flex', flexDirection: 'row', placeContent: 'center', paddingBottom: rsvpactive ? 0 : 30 }}>
        {socialmedias.map((media, i) => media.length > 0 ? <div key={'socialmedia' + i} style={{ padding: 3, margin: 3 }}>{INVITESOCIALMEDIASIM_ARR[i]}</div> : null)}
        {(promote && promote.length > 0) ? <div style={{ padding: 3, margin: 3, borderLeft: 'thin solid rgba(192, 192, 192, 0.37)' }}>{HUMANSIM_ICON}</div> : null}
    </div>

    const devicedim = 20
    const GENERALICON_CSS = { width: devicedim, height: devicedim, display: 'flex', margin: 4 }

    const LOGO_MAP = {
        'RSVP': iconwrapper(RSVP_ICON, GENERALICON_CSS),
        'Gallery': iconwrapper(GALLERY_ICON, GENERALICON_CSS),
        'Itinerary': iconwrapper(ITINERARY_ICON, GENERALICON_CSS),
        'Contact': iconwrapper(RSVPTELEPHONE_ICON, GENERALICON_CSS),
        'Seatings': iconwrapper(SEATINGS_ICON, GENERALICON_CSS),
        'Guestbook': iconwrapper(GUESTBOOK_ICON, GENERALICON_CSS),
        'More': iconwrapper(SMALLERMORE_ICON, GENERALICON_CSS),
        'Share': iconwrapper(SOCIALMEDIA_ICON, GENERALICON_CSS),
        'Promote': iconwrapper(PROMOTE_ICON, GENERALICON_CSS),
        'Registry': iconwrapper(REGISTRY_ICON, GENERALICON_CSS),
    }

    const nav_dom = menutype === 'btmnavbar'    // btm bar navigation  -  menutype ,menuseq, menustyle
        ? <div key={stylenavupdate} className='T1sim_m_nav' style={{ width: '100%', fontFamily: btmbarff, backgroundColor: menustyle.backgroundColor, border: `0.5px solid ${menustyle.borderColor}`, borderBottom: 'none', placeContent: 'center' }}>
            {props.menuseq.map((ms, index) => {
                if (ms === 'RSVP' && !rsvpactive) { return null }

                if (menuicongate) {
                    return <div className='T1simmobile_navitem' key={index + 'ms'} style={{ border: menustyle.borderColor, color: menustyle.color, }}>
                        {menuicongate ? LOGO_MAP[ms] : null}
                        <div className='ilookup_btmtxt' style={{ fontSize: 6, height: 'max-content' }}>{ms}</div>
                    </div>

                }
                else {
                    return <div className='T1simmobile_navitem_withouticon' key={index + 'ms'} style={{ border: menustyle.borderColor, color: menustyle.color, }}>
                        <div className='ilookup_btmtxt' style={{ fontSize: 9, height: 'max-content' }}>
                            {ms}
                        </div>
                    </div>

                }
            })}
        </div>
        : menutype === 'stickytopnav' ?
            <div key={stylenavupdate} className='T1sim_m_topnav' style={{ width: '100%', fontFamily: btmbarff, backgroundColor: menustyle.backgroundColor, borderBottom: `0.5px solid ${menustyle.borderColor}`, placeContent: 'center' }}>
                {props.menuseq.map((ms, index) => {
                    if (ms === 'RSVP' && !rsvpactive) {
                        return null
                    }
                    return <div
                        key={index + 'ms'}
                        className='T1simmobile_topnavitem'
                        style={{ border: menustyle.borderColor, color: menustyle.color, }}
                    >
                        {ms}
                    </div>
                })}
            </div>
            : menutype === 'none'
                ? null
                : null


    const title_dom = nameposchange
        ? <div style={{ height: '50%', alignItems: 'center', display: 'flex' }}>{
            [
                <Textfit key={"m" + ntm + wt + nameposchange} style={{ top: nameposchange ? `calc( 30% - ${(title_1.mobilesimulator_ht) / 2}px - 10px )` : `calc( 50% - ${(title_0.mobilesimulator_ht) / 2}px - 10px )`, height: title_0.mobilesimulator_ht, width: wt - 60, fontFamily: secff, color: fc, margin: '10px 30px', display: 'flex', flexDirection: 'column', placeContent: 'center', fontWeight: 'normal', position: 'relative', lineHeight: 'normal', alignItems: 'center', border: debug_guideline ? '1px solid black' : 'none' }}>
                    <div style={{ height: title_0.mobilesimulator_ht * title_0.title_layer1, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end' }}>{name}</div>
                    <Textfit style={{ height: title_0.mobilesimulator_ht * title_0.title_layer2, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline' }}>{'&'}</Textfit>
                    <div style={{ height: title_0.mobilesimulator_ht * title_0.title_layer3, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-start' }}>{spousename}</div>
                </Textfit>,
                <Textfit key={"m" + ntm + wt + nameposchange} style={{ top: nameposchange ? `calc( 35% - ${(title_1.mobilesimulator_ht) / 2}px - 10px )` : `calc( 50% - ${(title_1.mobilesimulator_ht) / 2}px - 10px )`, height: title_1.mobilesimulator_ht, width: wt - 60, fontFamily: secff, color: fc, margin: '10px 30px', display: 'flex', flexDirection: 'column', placeContent: 'center', position: 'relative', lineHeight: 'normal', alignItems: 'center', border: debug_guideline ? '1px solid black' : 'none' }}>
                    <div style={{ height: title_1.mobilesimulator_ht * title_1.title_layer1, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end' }}>{name}</div>
                    <div style={{ height: title_1.mobilesimulator_ht * title_1.title_layer2, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-start' }}>{"& " + spousename}</div>
                </Textfit>,
                <Textfit key={"m" + ntm + wt + nameposchange} style={{ top: nameposchange ? `calc( 35% - ${(title_1.mobilesimulator_ht) / 2}px - 10px )` : `calc( 50% - ${(title_2.mobilesimulator_ht) / 2}px - 10px )`, height: title_2.mobilesimulator_ht, width: wt - 60, fontFamily: secff, color: fc, margin: '10px 30px', padding: '0px 10px', placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', position: 'relative', alignItems: 'center', border: debug_guideline ? '1px solid black' : 'none' }}>
                    {name + ' & ' + spousename}
                </Textfit>
            ][ntm]
        }
        </div>
        : [
            <Textfit key={"m" + ntm + wt + nameposchange} style={{ top: nameposchange ? `calc( 30% - ${(title_1.mobilesimulator_ht) / 2}px - 10px )` : `calc( 50% - ${(title_0.mobilesimulator_ht) / 2}px - 10px )`, height: title_0.mobilesimulator_ht, width: wt - 60, fontFamily: secff, color: fc, margin: '10px 30px', display: 'flex', flexDirection: 'column', placeContent: 'center', fontWeight: 'normal', position: 'relative', lineHeight: 'normal', alignItems: 'center', border: debug_guideline ? '1px solid black' : 'none' }}>
                <div style={{ height: title_0.mobilesimulator_ht * title_0.title_layer1, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end' }}>{name}</div>
                <Textfit style={{ height: title_0.mobilesimulator_ht * title_0.title_layer2, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline' }}>{'&'}</Textfit>
                <div style={{ height: title_0.mobilesimulator_ht * title_0.title_layer3, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-start' }}>{spousename}</div>
            </Textfit>,
            <Textfit key={"m" + ntm + wt + nameposchange} style={{ top: nameposchange ? `calc( 35% - ${(title_1.mobilesimulator_ht) / 2}px - 10px )` : `calc( 50% - ${(title_1.mobilesimulator_ht) / 2}px - 10px )`, height: title_1.mobilesimulator_ht, width: wt - 60, fontFamily: secff, color: fc, margin: '10px 30px', display: 'flex', flexDirection: 'column', placeContent: 'center', position: 'relative', lineHeight: 'normal', alignItems: 'center', border: debug_guideline ? '1px solid black' : 'none' }}>
                <div style={{ height: title_1.mobilesimulator_ht * title_1.title_layer1, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end' }}>{name}</div>
                <div style={{ height: title_1.mobilesimulator_ht * title_1.title_layer2, width: ((wt - 20) * 0.95) - 50, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-start' }}>{"& " + spousename}</div>
            </Textfit>,
            <Textfit key={"m" + ntm + wt + nameposchange} style={{ top: nameposchange ? `calc( 35% - ${(title_1.mobilesimulator_ht) / 2}px - 10px )` : `calc( 50% - ${(title_2.mobilesimulator_ht) / 2}px - 10px )`, height: title_2.mobilesimulator_ht, width: wt - 60, fontFamily: secff, color: fc, margin: '10px 30px', padding: '0px 10px', placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', position: 'relative', alignItems: 'center', border: debug_guideline ? '1px solid black' : 'none' }}>
                {name + ' & ' + spousename}
            </Textfit>
        ][ntm]

    const seq_dom = {
        'maintext': maintext_dom,
        'location': location_dom,
        'date': datetime_dom,
        'howwemet': howwemet_dom,
        'proposal': proposal_dom,
        'schedule': schedule_dom,
        'qna': qns_dom,
        'map': map_dom,
        'party': party_dom,
        'rsvp': rsvp_dom,
    }

    return <div className="simulator_noselect" style={{ width: 'max-content', height: 'max-content', display: 'flex', flexDirection: 'row' }}>
        <div className="T1simmobile_root" style={{ paddingTop: menutype === 'stickytopnav' ? 30 : 0, width: wt, height: ht, backgroundColor: templateattr_map && templatetype ? templateattr_map[templatetype]['templatecolor'] : '', backgroundImage: `url(${textures[0]})`, display: 'flex', flexDirection: 'column', borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.13) 0px 10px 50px', position: 'relative', overflow: 'hidden', fontFamily: css_map['othertext'].fontFamily }}>
            <div className="T1simmobile_root2" ref={scrollcontainerref} style={{ width: '100%', height: ht, overflowY: 'overlay', overflowX: 'hidden', paddingBottom: 80 }}>
                <div style={{ width: `100%`, height: ht, overflowWrap: 'break-word', position: 'relative', display: 'flex', overflow:'hidden' }}>
                    {title_dom}
                    <T1border styleborder={styleborder} simulatordevice={'MOBILE'} styleborderwt={styleborderwt} styleborderbr={styleborderbr} stylebordercolor={stylebordercolor} />
                    {bg()}
                </div>
                {mainimg_dom}
                {displayseq.map((seqkey) => seq_dom[seqkey])}
            </div>
            {nav_dom}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', width: 40, placeContent: 'flex-end' }}>
            <button className="simulator_mobileclickscroll simulator_noselect" onClick={scrollup} {...onLongPress(scrollup)} >
                {iconwrapper(ARROWDOWN_ICON, { width: 25, height: 25, marginBottom: 5, transform: 'rotate(180deg)' })}
            </button>
            <button className="simulator_mobileclickscroll simulator_noselect" onClick={scrolldown} {...onLongPress(scrolldown)} >
                {iconwrapper(ARROWDOWN_ICON, { width: 25, height: 25 })}
            </button>
        </div>
    </div>
}

export default T1simmobile
